export function randomInt(min = 0, max = 1) {
    // Check if min is really the min
    if (min > max) {
        const tmp = max
        max = min
        min = tmp
    }

    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function randomIntBetween(min = 0, max = 1) {
    // Check if min is really the min
    if (min > max) {
        const tmp = max
        max = min
        min = tmp
    }

    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function random(min = 0, max = 1) {
    // Check if min is really the min
    if (min > max) {
        const tmp = max
        max = min
        min = tmp
    }

    return Math.random() * (max - min + 1) + min
}

export function randomBetween(min = 0, max = 1) {
    // Check if min is really the min
    if (min > max) {
        const tmp = max
        max = min
        min = tmp
    }

    return Math.random() * (max - min + 1) + min
}



// WEBPACK FOOTER //
// ./src/scripts/utils/Random.js